// PlayerCard.js  ← FINAL WORKING VERSION
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function PlayerCard({ playerId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(
          `https://qgcycgukngpzmdobabhc.supabase.co/functions/v1/get-player-stats/${playerId}?season=2025`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
            },
          }
        );

        const player = res.data.player;
        const stats = res.data.offensive_stats || [];

        // Sum all games in 2025
        const totals = stats.reduce(
          (acc, game) => ({
            passYds: acc.passYds + (game.passing_yards || 0),
            rushYds: acc.rushYds + (game.rushing_yards || 0),
            rec: acc.rec + (game.receptions || 0),
          }),
          { passYds: 0, rushYds: 0, rec: 0 }
        );

        setData({
          name: player.name || "Player",
          team: player.team_abbr || "FA",
          position: player.position || "N/A",
          passYds: Math.round(totals.passYds),
          rushYds: Math.round(totals.rushYds),
          rec: totals.rec,
        });
        setLoading(false);
      } catch (err) {
        console.error("PlayerCard error:", err);
        setLoading(false);
      }
    };
    fetch();
  }, [playerId]);

  if (loading || !data) return null;

  return (
    <Link to={`/player/${playerId}`} className="block">
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-5 rounded-xl hover:scale-105 transition transform shadow-lg">
        <h3 className="text-xl font-bold">{data.name}</h3>
        <p className="text-sm opacity-90">
          {data.position} • {data.team}
        </p>
        <div className="mt-3 grid grid-cols-3 gap-2 text-center text-sm">
          <div>
            <div className="font-bold">{data.passYds}</div>
            <div className="text-xs">Pass</div>
          </div>
          <div>
            <div className="font-bold">{data.rushYds}</div>
            <div className="text-xs">Rush</div>
          </div>
          <div>
            <div className="font-bold">{data.rec}</div>
            <div className="text-xs">Rec</div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default PlayerCard;
